import type React from "react"
import * as Yup from "yup"
import PCNumberInput from "./PCNumberInput"

export const initialValues = {
  serviceId: "ASP",
  domains: 1,
}

export const validationSchema = Yup.object({
  domains: Yup.number().min(1, "Must add at least 1.").required("Required"),
})

const ASPServiceForm: React.FC = () => {
  return (
    <>
      <h1>Attack Surface Profiler Options</h1>
      <PCNumberInput name="domains" label="Number of Domains" />
    </>
  )
}

export default ASPServiceForm
